import { Routes, Route, Outlet } from "react-router-dom";
import { Perfil } from "../pages/Perfil";
import { Page404 } from "../pages/404";
import ProtectedRoutes from "./protectedRoutes/ProtectedRoutes";
import { ResetPassword } from "../pages/ResetPassword";
import { Ultimas } from "../pages/Ultimas";
import { Top } from "../pages/Top";
import { Mungangos } from "../pages/Mungangos";

export const RoutesMain = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoutes />}>
        <Route element={<Outlet />}>
          <Route path="/ultimas" element={<Ultimas />} />
          <Route path="/" element={<Ultimas />} />
          <Route path="/mungangos" element={<Mungangos />} />
          <Route path="/top" element={<Top />} />
        </Route>
        <Route path="/perfil/:username" element={<Perfil />} />
      </Route>
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};
